import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { PackagingModelFormContext } from 'context';
import type {
  ComponentMode,
  PackagingModel as PackagingModelConfig,
} from 'types';

import { PackagingModelForm, PackagingModelHeader } from './components';

type PackagingModelProps = {
  mode: ComponentMode;
};

export default function PackagingModel({ mode }: PackagingModelProps) {
  const data = useLoaderData() as PackagingModelConfig | undefined;

  const { name } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const title = isUpdatedMode ? name : 'افزودن بسته‌بندی جدید';
  const defaultName = isUpdatedMode ? name : '';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <PackagingModelHeader>{title}</PackagingModelHeader>
      <PackagingModelFormContext
        mode={mode}
        defaultName={defaultName}
        {...(isUpdatedMode ? data : {})}
      >
        <PackagingModelForm />
      </PackagingModelFormContext>
    </React.Fragment>
  );
}
